import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Logout } from '../state/app.actions';
import { AppState } from '../state/app.state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const jwt = this.store.selectSnapshot(AppState.selectJwt);

    // Don't include the request to internationalization assets
    if (req.url.includes('/assets/i18n/')) {
      return next.handle(req);
    }

    if (jwt) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${jwt}`),
      });

      return next.handle(cloned).pipe(
        catchError((err) => {
          if ((err instanceof HttpErrorResponse && err.status === 401) || err.status === 0) {
            this.store.dispatch(new Logout());
          }

          return throwError(err);
        })
      );
    } else {
      this.store.dispatch(new Logout());
      return throwError(new Error('Failed to fetch auth token'));
    }
  }
}
